module.exports = __webpack_public_path__ + "img/Back Wing Left.c608a5e2.png";